import { useUser } from "../../../../api/useUser";
import { useCanUserDoOnProject, useHasUserRole } from "../../../canUserDo";
import type { DashboardModelT } from "../schema/dashboard";

export function useCanManageSharing(dashboard: DashboardModelT | null) {
  const user = useUser();
  const isAllProjectSetuper = useHasUserRole(user, "ALL_PROJECTS_SETUPER");
  const isSuperAdmin = useHasUserRole(user, "SUPER_ADMIN");
  const isAdmin = useHasUserRole(user, "ADMIN");
  const canSetupProject = useCanUserDoOnProject("PROJECT_SETUP", dashboard?.projectId ?? "");
  const isAuthor = dashboard?.createdByUserId === user.id;
  return isSuperAdmin || isAdmin || isAllProjectSetuper || canSetupProject || isAuthor;
}
